<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item label="">
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <el-form-item label="发送时间">
                <el-date-picker
                        v-model="queryDate"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="formInline.messageType" clearable filterable placeholder="类型" @change="onMessageType">
                    <el-option v-for="item in typeList"
                               :key="item.key"
                               :label="item.value"
                               :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="消息模板" v-show="showTemplate">
                <el-select v-model="formInline.messageId" filterable clearable  placeholder="消息模板">
                    <el-option v-for="item in wechatTemplateList"
                               :key="item.messageId"
                               :label="item.messageName"
                               :value="item.messageId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客服消息关键字" v-show="showKeyworld">
                <el-select v-model="formInline.messageId" filterable clearable  placeholder="客服消息关键字">
                    <el-option v-for="item in keyworldList"
                               :key="item.id"
                               :label="item.keyword"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台" v-show="false">
                <el-select v-model="formInline.platformId" clearable filterable placeholder="平台">
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="getList()">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="nickName" label="昵称" width="100"></el-table-column>
            <el-table-column label="用户头像" width="100">
                <template slot-scope="scope">
                    <el-avatar size="small" :src="scope.row.headImageUrl"></el-avatar>
                </template>
            </el-table-column>
            <el-table-column prop="messageTypeName" label="消息类型" width="100"></el-table-column>
            <el-table-column prop="messageName" label="消息名称" width="100"></el-table-column>
            <el-table-column prop="errCode" label="状态码" width="100"></el-table-column>
            <el-table-column prop="resultMessage" label="推送结果" width="100"></el-table-column>
            <el-table-column prop="errMsg" label="错误信息" width="100"></el-table-column>
            <el-table-column prop="createTime" label="发送时间" width="220"></el-table-column>
            <el-table-column prop="platformName" label="平台" width="100"></el-table-column>
            <el-table-column prop="messageContent" label="消息内容" fixed="right" >
            </el-table-column>

        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getTemplateMessageLogList, getPlatformList, getKeywordsOption,listTemplateMessage} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                loading: false,
                showTemplate:false,
                showKeyworld:false,
              wechatTemplateList:[],
                typeList: [
                    {key: 1, value: '客服消息'},
                    {key: 2, value: '模板消息'}
                ],
                keyworldList:[],
                templateList:[],
                queryDate:[this.$route.query.start+" 00:00:00",this.$route.query.end+" 23:59:59"],
                form: {
                    source: '',
                    start: this.$route.query.start+" 00:00:00",
                    end: this.$route.query.end+" 23:59:59",
                    currentPage: 1,
                    pageSize: 15,
                },
                formInline: {
                    source: '',
                    start: this.$route.query.start+" 00:00:00",
                    end:  this.$route.query.end+" 23:59:59",
                    messageId: this.$route.query.messageId,
                    isSuccess: this.$route.query.isSuccess,
                    messageType:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天内',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近两天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                platformDisabled: false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getList();
            this.getEnableKeyworldList();
            this.getTemplateList();
            this.getPlatformListData();
        },
        methods: {
            //定义查询方法
            getPlatformListData(){
                getPlatformList(this.formInline).then((res) => {
                    this.platformData = res.data;
                })
            },
            onMessageType(type){
                if(type==1){
                    this.showTemplate=false;
                    this.showKeyworld=true;
                }else if(type=2){
                    this.showTemplate=true;
                    this.showKeyworld=false;
                }
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId:1}).then((res) => {
                    this.keyworldList = res.data.filter(item => item.type=='text');
                    this.keyworldList.push({'id':0,'keyword':'无'});
                });
            },
            getTemplateList(){
                this.loading = true;
                listTemplateMessage({
                    currentPage: 1,
                    pageSize: 250
                }).then((res) => {
                    this.wechatTemplateList = res.data.messageList.list;
                })
            },
            getList(){
                this.loading = true;
                if(this.queryDate!=''&&this.queryDate!=null){
                    this.formInline.start=this.queryDate[0];
                    this.formInline.end=this.queryDate[1];
                }
                getTemplateMessageLogList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.listData = res.data.value.list;
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            returnHistory(){
                window.history.back()
            }
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/messageLog.vue